(ns frontend.view.modals.curtains.tenant-custom-filter-curtain.view
  (:require
   [common.localization :as loc]
   [common.schema.registry :as registry]
   [frontend.state.association :as association]
   [frontend.state.current-session :as session]
   [frontend.view.modals.curtains.tenant-custom-filter-curtain.events :as events]
   [reagent.core :as r]
   [ui.components.modal.view :as modal]
   [ui.editors.labelled-input.view :as labelled-input]))

(defonce modal-key :tenant-custom-curtain/filter)

(defn view
  [{:keys [shown? topmost? close-modal! props state]}]
  (let [filter-state (r/cursor state [:data])
        key-state (r/cursor state [:filter-key])
        button-state (r/cursor state [:button-enabled])
        error-state (r/cursor state [:error-text])
        froppos-in-current-pipeline (->> @session/all-fundraising-opportunities
                                         (filter (fn [fo]
                                                   (= (:fundraising-opportunity/pipeline fo)
                                                      @session/selected-froppo-pipeline)))
                                         (vec))
        associations (->> froppos-in-current-pipeline
                          (mapcat
                           (fn [froppo]
                             (association/resolve-related-entities-by-group froppo
                                                                            :entity.type/person))))]
    (events/reset-state filter-state
                        button-state
                        (select-keys props
                                     [:selected-countries
                                      :selected-association-types
                                      :selected-cities]))
    (fn [{:keys [shown? topmost? close-modal! props state class-name]}]
      (let [{:keys [on-ok!]} props
            tenant-schema @session/tenant-schema
            association-type-country-city
            (some->>
             associations
             (group-by first)
             (map
              (fn [[association-type grouped-vals]]
                (let [persons
                      (->>
                       grouped-vals
                       (mapcat
                        (fn [[_ type-associations]]
                          (->> type-associations
                               (map (fn [association]
                                      (let [source (:entity-association/target-entity association)
                                            target (:entity-association/source-entity association)]
                                        (if (= :entity.type/person
                                               (:entity/type (get @session/entities source)))
                                          (get @session/entities source)
                                          (get @session/entities target)))))
                               (remove nil?))))
                       (remove nil?))]
                  [association-type
                   (->> persons
                        (map (fn [p]
                               (when-let [country (:person/location-country p)]
                                 [country (:person/location-city p)])))
                        (remove nil?)
                        (group-by first)
                        (sort-by first)
                        (map (fn [[country country-cities]]
                               [country
                                (some->> country-cities
                                         (map second)
                                         (remove nil?)
                                         (distinct)
                                         (sort))]))
                        (into {}))])))
             (into {}))
            selected-types (:selected-association-types @filter-state)
            countries-in-selected-type (->> selected-types
                                            (mapcat (fn [selected-type]
                                                      (get association-type-country-city
                                                           selected-type)))
                                            (remove nil?))
            selected-countries (:selected-countries @filter-state)
            cities-in-selected-country (->> countries-in-selected-type
                                            (mapcat (fn [[country cities]]
                                                      (when (some #{country} selected-countries)
                                                        cities)))
                                            (remove nil?))
            selected-cities (:selected-cities @filter-state)]
        [modal/view
         {:visible?      (and shown? topmost?)
          :hide!         close-modal!
          :backdrop      "static"
          :close-button? true}
         (loc/tr :filter-by-contact-location)
         [:div
          {:class "flex flex-col gap-4"}
          (when @error-state
            [:div
             {:class "bg-danger-light"}
             (str @error-state)])
          [labelled-input/view
           {:editor-type :editor.type/multi-select
            :data-type   :data.type/keyword-multi
            :label       (loc/tr :type)
            :value       selected-types
            :options     (->> association-type-country-city
                              (keys)
                              (mapv (fn [k]
                                      {:value k
                                       :label (loc/field-name k (registry/get-field-schema tenant-schema k))})))
            :on-change   (fn [new-value & _]
                           (if (empty? new-value)
                             (swap! filter-state dissoc :selected-association-types)
                             (swap! filter-state assoc :selected-association-types new-value))
                           (swap! filter-state dissoc :selected-countries :selected-cities))}]

          [labelled-input/view
           {:editor-type :editor.type/multi-select
            :label       (loc/tr :country)
            :value       selected-countries
            :options     (->> countries-in-selected-type
                              (keys)
                              (mapv (fn [k]
                                      {:value k :label k})))
            :on-change   (fn [new-value & _]
                           (if (empty? new-value)
                             (swap! filter-state dissoc :selected-countries)
                             (swap! filter-state assoc :selected-countries new-value))
                           (swap! filter-state dissoc :selected-cities)
                           (events/validate! filter-state button-state))}]

          [labelled-input/view
           {:editor-type :editor.type/multi-select
            :label       (loc/tr :city)
            :value       selected-cities
            :options     (->> cities-in-selected-country
                              (mapv (fn [city]
                                      {:value city :label city})))
            :on-change   (fn [new-value & _]
                           (if (empty? new-value)
                             (swap! filter-state dissoc :selected-cities)
                             (swap! filter-state assoc :selected-cities new-value)))}]]
         [:<>
          [modal/left-cancel-only close-modal! nil]
          [modal/right-single-button
           nil
           false
           (fn [_]
             ;;remove unnecessary lower/upper-bound-values from state:
             (on-ok! @filter-state)
             (close-modal!))
           (loc/tr :ok)
           nil]]]))))
